import accountingSoftware from './svgs/Accounting-Software.svg';
import flinks from './svgs/flinks.svg';
import globalPayments from './svgs/global-payments.svg';
import invertie from './svgs/Inverite.svg';
import ipAddress from './svgs/ip-address.svg';
import paylink from './svgs/paylink.svg';
import plaid from './svgs/plaid.svg';
import webhooks from './svgs/webhooks.svg';
import brandSettings from './svgs/brand-settings.png';

export type SettingsCardImgs =
  | 'accountingSoftware'
  | 'flinks'
  | 'globalPayments'
  | 'invertie'
  | 'ipAddress'
  | 'paylink'
  | 'plaid'
  | 'webhooks'
  | 'brandSettings';
/** `alt` text is not stored here — it is localized in SettingsCard via `UI.SettingsCard.Alt.<key>`. */
export const SettingsCardImgsMap: { [key in SettingsCardImgs]: { src: string } } = {
  accountingSoftware: { src: accountingSoftware },
  brandSettings: { src: brandSettings },
  flinks: { src: flinks },
  globalPayments: { src: globalPayments },
  invertie: { src: invertie },
  ipAddress: { src: ipAddress },
  paylink: { src: paylink },
  plaid: { src: plaid },
  webhooks: { src: webhooks },
};
